import { render } from "./FormulasTrait.vue?vue&type=template&id=3d9b2b16"
import script from "./FormulasTrait.vue?vue&type=script&lang=js"
export * from "./FormulasTrait.vue?vue&type=script&lang=js"

import "./FormulasTrait.vue?vue&type=style&index=0&id=3d9b2b16&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__